import {m} from '@codeurs/front'
import stream from 'mithril/stream'
import {Component, Fragment} from 'react'
import {MTMTracking} from 'util/trackers'
import {CookiesType} from 'views/partials/cookiewarning'

export class Tracking extends Component<{
	view: any // ClassComponents<{cookies: boolean}>
	cookiesData: CookiesType
	mtmCode?: string
}> {
	cookies = stream(
		localStorage ? !!localStorage.getItem('acceptedCookies') : false
	)
	componentDidMount() {
		this.cookies.map(accept => {
			if (localStorage) {
				if (accept) localStorage.setItem('acceptedCookies', 'true')
				else localStorage.removeItem('acceptedCookies')
			}
		})
	}
	render() {
		const {view: Cookiewarning, cookiesData, mtmCode} = this.props
		const acceptedCookies = this.cookies()
		return (
			<Fragment>
				{/* <Cookiewarning cookies={this.cookies} cookiesData={cookiesData} /> */}
				{mtmCode && (
					<MTMTracking id={mtmCode} acceptedCookies={acceptedCookies} />
				)}
			</Fragment>
		)
	}
}
